import React, { useEffect, useRef, useState } from 'react';
import styles from './SalonAvatarModal.module.scss';
import CropImageComponent from '../../../Common/CropImageComponent';
import UploadFileModal from '../../../Common/UploadFileModal';
import clx from 'classnames';
import { authActions } from '../../store';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';

const SalonAvatarModal = ({ callback, closeModal, isEditForm }) => {
  const dispatch = useDispatch();
  const [imgValue, setImageValue] = useState('');
  const [fullImg, setFullImg] = useState('');
  const childRef = useRef();
  const { t } = useTranslation();
  const hasPreview = Boolean(fullImg?.url);

  useEffect(() => {
    if (!imgValue) return;
    if (isEditForm) {
      callback(imgValue);
      dispatch(
        authActions.EDIT_SALON_AVATAR.REQUEST(
          {
            imgBase64: imgValue,
          },
          closeModal,
        ),
      );
    } else {
      callback(imgValue);
      closeModal();
    }
  }, [imgValue]);

  return (
    <div className={styles.worker_avatar_modal_container}>
      <p className={styles.helper}>
        {hasPreview
          ? t('modals.global.workerAvatar.cropHint')
          : t('modals.global.salonAvatar.create')}
      </p>

      <div className={styles.upload_zone}>
        <UploadFileModal
          isMultiple={false}
          setUploadFiles={setFullImg}
          accept="image/*"
          title={t('common.upload.cta')}
          hint={t('common.upload.imageHint')}
        />
      </div>

      {hasPreview ? (
        <div className={styles.crop_wrap}>
          <CropImageComponent setImageValue={setImageValue} url={fullImg.url} ref={childRef} />
        </div>
      ) : null}

      <div className={styles.button_block}>
        <button type="button" onClick={closeModal} className={styles.return_button}>
          {t('common.actions.cancel')}
        </button>
        <button
          type="button"
          className={clx(styles.confirm_button, {
            [styles.confirm_button_disabled]: !hasPreview,
          })}
          disabled={!hasPreview}
          onClick={() => childRef.current?.setCroppedImage()}
        >
          {t('common.actions.save')}
        </button>
      </div>
    </div>
  );
};

export default SalonAvatarModal;
